export const EXCLUDE_SYSTEM_MESSAGES = "EXCLUDE_SYSTEM_MESSAGES";
export const EXCLUDE_INKLE_ADMIN_MESSAGES = "EXCLUDE_INKLE_ADMIN_MESSAGES";

export const ADMIN_SENDER_STREAM_USER_IDS = [
  "b9047104-98d3-454c-a2c7-3a873b943bd2",
];
